import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import Editor from './Editor';

function Languages() {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();

  // Only render if this is a modal route (background state exists)
  const isModal = location.state?.background;

  const handleClose = useCallback(() => navigate(`/resume/${id ?? ''}`), [navigate, id]);

  // Don't render if not a modal
  if (!isModal) return null;

  return <Editor onClose={handleClose} />;
}

Languages.propTypes = {};

export default Languages;
